import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Banner from "../components/service/Banner";
import Header from "../layouts/Header";
import { Col, Container, Row } from "react-bootstrap";
import SectionHeader from "../components/sectionHeader";
import SectionSubHeader from "../components/sectionSubHeader";
import Features from "../components/service/Features";
import JoinOurTeam from "../components/Home/JoinOurTeam";
import Footer from "../layouts/Footer";


const ExecutiveSearch = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const approach = [
    {
      image: "/images/target.svg",
      main: "Tailored Talent Strategy ",
      sub: " We partner closely with you to understand your business priorities and leadership needs.",
    },
    {
      image: "/images/finance.svg",
      main: "Discreet & Confidential Process ",
      sub: "Protecting your brand reputation while engaging with high-caliber talent.",
    },
    {
      image: "/images/dashboard.svg",
      main: "Global Reach, Local Insight ",
      sub: " Combining international networks with on-the-ground market intelligence. ",
    },
    {
      image: "/images/Prioritizing.svg",
      main: "Proven Track Record ",
      sub: "  Successful placements across industries and geographies.",
    },
    // {
    //   image: "/images/Safeguarding.svg",
    //   main: "Ongoing HR advisory & ",
    //   sub: "scaling support",
    // },
    // {
    //   image: "/images/smart.svg",
    //   main: "Build your India presence with confidence ",
    //   sub: "Volto Consulting makes it seamless.",
    // },
  ];

  const featureData = {
    service_name: "OUR  SERVICE HIGHLIGHTS",
    title: "GCC Setup",
    list: [
      {
        icon: "/images/gcc-1.svg",
        title: "Launch your Global Capability Center in India ",
        content:
          " from market entry strategy and site selection to regulatory compliance and operational rollout. Executive Search",
      },
      {
        icon: "/images/gcc-2.svg",
        title:
          "Attract and secure top leadership with our bespoke search process",
        content:
          "identifying, assessing, and onboarding executive talent aligned with your vision. Contractual Services",
      },
      {
        icon: "/images/gcc-3.svg",
        title: "Flexible workforce solutions ",
        content:
          " from contract hiring and project pods to Statement of Work (SOW)-based models — ensuring scale, speed, and agility.",
      },
    ],
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="volto-homepage service  light-theme">
        <Header />
        <div className="GCC-banner text-left">
        <Banner
          mode="dark"
          bannerImg="/images/executive-search.webp"
          title="Executive Search"
          main_content="At Volto Consulting, we connect organizations with exceptional leaders who drive growth, innovation, and transformation, aligning perfectly with your vision and culture."
        />
</div>
        <div className="service-info volto-section page-type-secvies">
          <Container className="">
            <SectionHeader mainText1={"Executive Search"} />
            <Row>
              <Col lg={6}>
                <SectionSubHeader
                  headerText={
                    "Finding transformative leaders who deliver impact from day one."
                  }
                />
              </Col>
              <Col lg={6} className="text-justify">
                <p>
                  {
                    "With deep industry expertise and an extensive global network, we deliver senior-level professionals across functions, from C-suite to niche leadership roles. Our rigorous, research-driven approach ensures that every leader we place brings measurable impact from day one."
                  }
                </p>
                
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="volto-section">
          <Row>
            <Col lg={5}>
              <img
                className="img-fluid h-100 mt-lg-4 "
                src="/images/executive.svg"
                alt="manufacturing-approch"
              />
            </Col>
            <Col lg={7}>
              <div className="industry-approach">
                <SectionHeader
                  mainText1={"Why Choose "}
                  mainText2={"Volto Executive Search"}
                />
                <SectionSubHeader
                  headerText={
                    "Delivering leadership that drives your next chapter of success"
                  }
                />
                <p className="industry-subtext mt-4">
                  Whether launching a venture, replacing a key executive, or driving growth, Volto Consulting delivers leaders who shape your organization’s future.
                </p>

                <Row className="approach-section">
                  {approach &&
                    approach.map((item, index) => {
                      return (
                        <Col lg={6} md={6} key={index} className="mb-4">
                          <img src={item?.image} alt={`approach-` + index} />
                          <h3>
                            {item?.main} <span>{item?.sub}</span>
                          </h3>
                        </Col>
                      );
                    })}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>

        {/* <Features data={featureData} /> */}
      </div>

      <JoinOurTeam image={"/images/join-our-team.webp"} />
      <Footer />
    </motion.div>
  );
};

export default ExecutiveSearch;
